import { render, staticRenderFns } from "./_modal.vue?vue&type=template&id=fb77b6c2&scoped=true&lang=pug"
import script from "./_modal.vue?vue&type=script&lang=js"
export * from "./_modal.vue?vue&type=script&lang=js"
import style0 from "./_modal.vue?vue&type=style&index=0&id=fb77b6c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb77b6c2",
  null
  
)

export default component.exports